import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SHEET_CONTENT_SIDE,
} from "@mozioinc/ui";
import { useTranslation } from "react-i18next";
import { ReactComponent as ArrowSvg } from "./assets/arrow.svg";
import type { TransNamespace } from "../types";

type PriceSummaryProps = {
  finalPrice: string;
  reservationPrice: string;
  amenities?: {
    label: string;
    value: string;
  }[];
  couponCode: string;
  couponDiscount: string;
};

const PriceSummary = ({
  finalPrice,
  reservationPrice,
  amenities,
  couponCode,
  couponDiscount,
}: PriceSummaryProps) => {
  const { t } = useTranslation<TransNamespace>("parking:price-summary");

  return (
    <Sheet>
      <SheetTrigger className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between bg-white px-3 py-2 shadow-2xl shadow-black lg:hidden">
        <h2 className="flex items-center gap-2 text-lg font-bold">
          <ArrowSvg className="text-primary rotate-180 text-xs" />
          {t("Total Price")}
        </h2>
        <div className="text-right">
          <p className="text-lg font-semibold">{finalPrice}</p>
          <p className="text-xs text-neutral-800">
            {t("Taxes and Fees included")}
          </p>
        </div>
      </SheetTrigger>
      <SheetContent side={SHEET_CONTENT_SIDE.BOTTOM}>
        <h2 className="border-b border-b-neutral-100 py-3 text-lg font-bold">
          {t("Your Summary")}
        </h2>
        <p className="flex justify-between border-b border-b-neutral-100 py-3">
          {t("Reservation")}
          <span>{reservationPrice}</span>
        </p>
        {amenities?.map((amenity) => (
          <p
            key={amenity.value}
            className="flex justify-between border-b border-b-neutral-100 py-3"
          >
            {amenity.label}
            <span>{amenity.value}</span>
          </p>
        ))}
        {Boolean(couponCode) && (
          <p className="flex justify-between border-b border-b-neutral-100 py-3">
            {t("Coupon")}: {couponCode}
            <span>-{couponDiscount}</span>
          </p>
        )}
        <div className="flex items-center justify-between py-3">
          <p className="flex items-center gap-2 text-lg font-bold">
            <ArrowSvg className="text-primary text-xs" />
            {t("Total Price")}
          </p>
          <div className="text-right">
            <p className="text-lg font-semibold">{finalPrice}</p>
            <p className="text-xs text-neutral-800">
              {t("Taxes and Fees included")}
            </p>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export { PriceSummary };
